export const QUESTION_TYPES = {
  GLOBAL: "global",
  CUSTOM: "custom",
  CODING: "coding",
  WRITING: "written",
  AI_GENERATED: "ai-generated",
  MCQ: {
    LOGICAL: "logical_reasoning",
    QUANTITATIVE: "quantitative",
    VERBAL: "verbal_reasoning",
    NUMBER: "number_system",
    CUSTOM_MCQ: "aptitude_custom",
    TECHNICAL_CUSTOM: "technical_custom",
  },
  MCQ_LIST: [
    "logical_reasoning",
    "quantitative",
    "verbal_reasoning",
    "number_system",
    "aptitude_custom",
    "technical_custom",
  ],
};

export const MCQ_SECTION_NAMES: Record<string, string> = {
  logical_reasoning: "Logical Reasoning",
  quantitative: "Quantitative Analysis",
  verbal_reasoning: "Verbal Reasoning",
  // number_system: "Number System",
  number_system: "Numerical Reasoning",
  aptitude_custom: "Custom MCQ",
  technical_custom: "Technical MCQ",
};
